import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, s as setBearerAuthToObject, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * SkroutzApi - axios parameter creator
 * @export
 */
const SkroutzApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {string} [orderCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByCode: async (orderCode, options = {}) => {
            const localVarPath = `/v1/Skroutz/GetOrderByCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (orderCode !== undefined) {
                localVarQueryParameter['orderCode'] = orderCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SkroutzWebhookToken} [SkroutzWebhookToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhook: async (SkroutzWebhookToken, options = {}) => {
            const localVarPath = `/v1/Skroutz/Webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SkroutzWebhookToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SkroutzApi - functional programming interface
 * @export
 */
const SkroutzApiFp = function (configuration) {
    const localVarAxiosParamCreator = SkroutzApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {string} [orderCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderByCode(orderCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderByCode(orderCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkroutzApi.getOrderByCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SkroutzWebhookToken} [SkroutzWebhookToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhook(SkroutzWebhookToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhook(SkroutzWebhookToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkroutzApi.webhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SkroutzApi - factory interface
 * @export
 */
const SkroutzApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SkroutzApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {string} [orderCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByCode(orderCode, options) {
            return localVarFp.getOrderByCode(orderCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SkroutzWebhookToken} [SkroutzWebhookToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhook(SkroutzWebhookToken, options) {
            return localVarFp.webhook(SkroutzWebhookToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SkroutzApi - object-oriented interface
 * @export
 * @class SkroutzApi
 * @extends {BaseAPI}
 */
class SkroutzApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {string} [orderCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkroutzApi
     */
    getOrderByCode(orderCode, options) {
        return SkroutzApiFp(this.configuration).getOrderByCode(orderCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SkroutzWebhookToken} [SkroutzWebhookToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkroutzApi
     */
    webhook(SkroutzWebhookToken, options) {
        return SkroutzApiFp(this.configuration).webhook(SkroutzWebhookToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { SkroutzApi, SkroutzApiAxiosParamCreator, SkroutzApiFactory, SkroutzApiFp };
//# sourceMappingURL=skroutz-api.js.map
